import builder from '../builder';
import SingleMan from '../../streamline-icons/light/single-man.svg';

export default builder('IconSingleManLight', SingleMan);
